// @ts-nocheck
import * as React from "react";

const EarthLine: React.FC = () => {
    return (
        <svg focusable="false" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.37501 7C1.37501 8.49184 1.96764 9.92258 3.02253 10.9775C4.07743 12.0324 5.50817 12.625 7.00001 12.625C8.49185 12.625 9.92259 12.0324 10.9775 10.9775C12.0324 9.92258 12.625 8.49184 12.625 7C12.625 5.50816 12.0324 4.07742 10.9775 3.02252C9.92259 1.96763 8.49185 1.375 7.00001 1.375C5.50817 1.375 4.07743 1.96763 3.02253 3.02252C1.96764 4.07742 1.37501 5.50816 1.37501 7Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.53951 8.875C4.65349 8.87499 4.76596 8.849 4.86839 8.79901C4.97082 8.74901 5.06051 8.67633 5.13064 8.58649C5.20077 8.49664 5.2495 8.39199 5.27313 8.28049C5.29676 8.16899 5.29467 8.05357 5.26701 7.943L4.89201 6.443C4.85143 6.28077 4.75779 6.13675 4.62598 6.03384C4.49417 5.93093 4.33174 5.87502 4.16451 5.875H1.48801C1.2812 6.89093 1.35929 7.94426 1.71365 8.91859C2.06802 9.89292 2.68486 10.7503 3.49601 11.396L4.00001 8.875H4.53951Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.4925 3.625H9.46051C9.29328 3.62502 9.13085 3.68093 8.99904 3.78384C8.86723 3.88675 8.77359 4.03077 8.73301 4.193L8.35801 5.693C8.33035 5.80357 8.32826 5.91899 8.35189 6.03049C8.37552 6.14199 8.42425 6.24664 8.49438 6.33649C8.56451 6.42633 8.6542 6.49901 8.75663 6.54901C8.85906 6.599 8.97153 6.62499 9.08551 6.625H9.87501L10.2705 9C10.2997 9.17512 10.3902 9.33419 10.5257 9.44891C10.6612 9.56363 10.833 9.62656 11.0105 9.6265H11.973C12.4724 8.68442 12.6925 7.61933 12.6074 6.55645C12.5223 5.49357 12.1355 4.47709 11.4925 3.6265V3.625Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(EarthLine);
